import React, {Component} from 'react';
import PropTypes from 'prop-types';

import PillBuilder from '../../classes/builder/pillBuilder';
import { VIEW_MODE } from '../../consts';
import { DEFAULT_STATE_FILTER } from '../../app/Search/reducer';
import Territory from '../../classes/geo/territory';
import { addClass, removeClass } from '../../utils/browser';

class Pills extends Component {
  constructor (props) {
    super(props);

    this.state = {
      expand: !props.enableClearAll
    };

    this.hiddenCount = 0;

    this.territory = new Territory(props.domain);

    this.handlerExpandAll = this.handlerExpandAll.bind(this);
    this.handlerResetAll = this.handlerResetAll.bind(this);
    this.handlerResetItem = this.handlerResetItem.bind(this);
    this.renderExpandPill = this.renderExpandPill.bind(this);
  }

  handlerExpandAll (e) {
    e.preventDefault();

    this.setState({
      expand: !this.state.expand
    });
  }

  handlerResetAll (e) {
    e.preventDefault();

    let filter = DEFAULT_STATE_FILTER;
    if (this.props.filter.get('viewMode') === VIEW_MODE.map) {
      filter = DEFAULT_STATE_FILTER.remove('viewMode').remove('bounds');
    }

    this.props.onUpdateFilter(filter);
  }

  handlerResetItem (resetFilter) {
    const update = this.props.onUpdateFilter;

    return function () {
      update(resetFilter);
    };
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateViewTags);
    this.props.enableClearAll && this.updateViewTags();
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateViewTags);
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.props.enableClearAll && this.updateViewTags();
  }

  updateViewTags () {
    const root = document.getElementsByClassName('applied-filters');
    if (!root.length) {
      return false;
    }

    const tags = document.getElementsByClassName('filter-tag');
    const tagsLength = tags.length;
    let withRoot = root[0].offsetWidth - 130 - 70;

    this.hiddenCount = tagsLength;

    for (let i = 0; i < tagsLength; i += 1) {
      const tag = tags[i];

      const prevDisplay = tag.style.display;
      const prevPosition = tag.style.position;
      const prevLeft = tag.style.left;

      tag.style.display = 'inline-block';
      tag.style.position = 'absolute';
      tag.style.left = '-1000px';

      const tagWith = parseInt(tag.offsetWidth) + 8;

      tag.style.display = prevDisplay;
      tag.style.position = prevPosition;
      tag.style.left = prevLeft;

      withRoot -= tagWith;
      if (withRoot > 0) {
        this.hiddenCount -= 1;
        removeClass(tag, 'tag-hide');
      } else {
        addClass(tag, 'tag-hide');
      }
    }

    const tagExpand = document.getElementsByClassName('filter-tag-expand');
    for (let i = 0; i < tagExpand.length; i += 1) {
      const tag = tagExpand[i];
      this.hiddenCount > 0 ? removeClass(tag, 'tag-hide') : addClass(tag, 'tag-hide');
      tag.innerHTML = `<label>Ещё ${this.hiddenCount}</label>`;
    }
  }

  getPills () {
    const { filter, dictionary, enableClearItem, dealType, realtyType } = this.props;

    const pillBuilder = new PillBuilder(filter, this.territory, dictionary, DEFAULT_STATE_FILTER);

    return pillBuilder.getPills(dealType, realtyType).map((data) => {
      return enableClearItem ? (
        <li className={'filter-tag tag-hide ' + data.key} key={data.key + data.label} onClick={this.handlerResetItem(data.filter)}>
          <label>{data.label}</label>
          <span className='icon icon-close' />
        </li>
      ) : (
        <li className={'filter-tag flat ' + data.key} key={data.key + data.label}>
          <label>{data.label}</label>
        </li>
      );
    }).toArray();
  }

  renderClearPill () {
    return (
      <li key='filter-tag-clear-all' className='filter-tag-clear-all no-print' onClick={this.handlerResetAll}>
        <label>Очистить фильтр</label>
      </li>
    );
  }

  renderExpandPill () {
    const className = this.state.expand ? 'filter-tag-collapse' : 'filter-tag-expand tag-hide';
    const title = this.state.expand ? 'Свернуть' : `Ещё {this.hiddenCount}`;

    return (
      <li key={className} className={className} onClick={this.handlerExpandAll}>
        <label>{title}</label>
      </li>
    );
  }

  renderBody (pills) {
    return (
      <div id='facet-pills-section' className='applied-filters'>
        <div className='pill-wrapper'>
          <ul className={'list-inline ' + (this.state.expand ? 'filter-tag-show-all' : '')}>
            { this.props.enableClearAll && this.renderClearPill() }
            { pills }
            { this.props.enableClearAll && this.renderExpandPill() }
          </ul>
        </div>
      </div>
    );
  }

  render () {
    const { wrapperClassName } = this.props;
    const pills = this.getPills();

    return pills.length > 0 && (
      wrapperClassName
        ? (<div className={wrapperClassName}>{this.renderBody(pills)}</div>)
        : this.renderBody(pills)
    );
  }
}

Pills.propTypes = {
  domain: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  wrapperClassName: PropTypes.string,
  enableClearAll: PropTypes.bool,                 // показывать кнопку сбросить весь фильтр
  enableClearItem: PropTypes.bool,                // показывать кнопку сбросить у каждого фильтра
  onUpdateFilter: PropTypes.func,
  dealType: PropTypes.string,
  realtyType: PropTypes.string
};
Pills.defaultProps = {
  wrapperClassName: null,
  enableClearAll: true,
  enableClearItem: true,
  onUpdateFilter: () => {}
};

export default Pills;



// WEBPACK FOOTER //
// ./src/ui/Controls/Pills.jsx